import { FlightNumberSearchFormErrorJSON } from '../models/flight-number-search-form';

export const formFlightNumberSearchErrors: FlightNumberSearchFormErrorJSON = {
    flightNumber: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'regex',
            message:
                'Flight number format: enter the 2 letter airline code followed by the flight number (between 1 and 4 digits). Roadfeeder/truck flight? add 1 letter at the end (e.g. ZZ1234T) or use format AGI followed by between 1 and 4 characters (e.g. AGI123Z or AGI9).',
        },
    ],
    date: [
        {
            code: 'required',
            message: 'Date is required',
        },
    ],
};
